import React from "react";

function TheIncreasing() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>The increasing popularity of NFTs</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  NFTs (Non-Fungible Tokens) have rapidly gained popularity as
                  they revolutionize the way digital assets are created, owned,
                  and traded. Unlike traditional cryptocurrencies, each NFT
                  represents a unique item, whether it's digital art,
                  collectibles, music, virtual real estate, or in-game assets.
                  The surge in interest is driven by creators, investors, and
                  businesses recognizing the potential of NFTs to authenticate
                  ownership and provide scarcity in the digital world. As
                  blockchain technology evolves, NFTs are becoming a crucial
                  part of the decentralized economy, offering new revenue
                  streams and creative opportunities for both individuals and
                  enterprises.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default TheIncreasing;
